/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect, useState } from "react";
import { useGLTF, useAnimations, MeshTransmissionMaterial } from "@react-three/drei";
import { CuboidCollider, RigidBody, quat } from '@react-three/rapier';
import { NodeToyMaterial } from '@nodetoy/react-nodetoy';
import { data } from './shaderData.js';
import { useControls } from 'leva';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three'


//function to move the door
export function Door({ position = [0, 0, 0] }) {

  const door = useRef()
  const { nodes, materials } = useGLTF('models/cube8.glb')


  useFrame((state, delta) => {
    const time = state.clock.getElapsedTime()
    const curRotation = quat(door.current.rotation())
    const incrementRotation = new THREE.Quaternion().setFromAxisAngle(
      new THREE.Vector3(0, 1, 0), Math.sin(time + Math.PI) * delta * 2);
    curRotation.multiply(incrementRotation);
    door.current.setNextKinematicRotation(curRotation);
  })

  return <group position={position}>
    <RigidBody ref={door} name="door" type="kinematicPosition" position={[4.822, 1.552, 0.745]} >
      <mesh
        name="Door"
        castShadow
        receiveShadow
        geometry={nodes.Door.geometry}
        material={materials.Door}
        position={[0, 0, 0]}
        rotation={[0, 0.061, 0]}
      />

    </RigidBody>
  </group>
}

//function to move the gate up and down

export function Gate({ position = [0, 0, 0] }) {
  const gate = useRef();
  const [timeOffset] = useState(() => Math.random() * Math.PI * 2)
  const { nodes, materials } = useGLTF('models/cube8.glb')

  useFrame((state) => {
    const time = state.clock.getElapsedTime()
    const y = Math.sin(time + timeOffset) * 1.25
    gate.current.setNextKinematicTranslation({ x: position[0] + 14.866, y: position[1] + 1.833 + y, z: position[2] - 0.287 })
  })

  return <group position={position}>
    <RigidBody type="kinematicPosition" name="gate"
      position={[14.866, 1.833, -0.287]} ref={gate}>
      <mesh
        name="gate"
        castShadow
        receiveShadow
        geometry={nodes.gate.geometry}
        material={materials['procedural dirty metal']}>
      </mesh>
    </RigidBody>
  </group>
}




//function to move the grate in the floor
export function FloorGrate({ position = [0, 0, 0] }) {

  const floorgrate = useRef()
  const { nodes, materials } = useGLTF('models/cube8.glb')

  useFrame((state, delta) => {
    const time = state.clock.getElapsedTime()

    const curRotation = quat(floorgrate.current.rotation())
    const incrementRotation = new THREE.Quaternion().setFromAxisAngle(
      new THREE.Vector3(0, 0, 1), Math.sin(time + Math.PI) * delta * 1);
    curRotation.multiply(incrementRotation);
    floorgrate.current.setNextKinematicRotation(curRotation);
  })


  return <group position={position}>
    <RigidBody ref={floorgrate} name="floorgrate" type="kinematicPosition" position={[8.543, -0.128, -0.173]}>
      <mesh
        name="gate001"
        castShadow
        receiveShadow
        geometry={nodes.gate001.geometry}
        material={materials['procedural dirty metal']}
      />
    </RigidBody>
  </group>
}





//function to move the gelatinous cube
export function Gelatinous_Cube({ position = [0, 0, 0] }) {

  const gelatine = useRef()
  const [timeOffset] = useState(() => Math.random() * Math.PI * 2)
  const { nodes, materials } = useGLTF('models/cube8.glb')

  useFrame((state, delta) => {
    const time = state.clock.getElapsedTime()

    const x = Math.sin(time + timeOffset) * 2.25
    const y = Math.cos(time + timeOffset) * 0.25
    const z = Math.cos(time + timeOffset) * 0.25
    gelatine.current.setNextKinematicTranslation({ x: position[0] + x, y: position[1] + 1 + y, z: position[2] - z})

    const curRotation = quat(gelatine.current.rotation())
    const incrementRotation = new THREE.Quaternion().setFromAxisAngle(
      new THREE.Vector3(Math.random(), Math.random(), Math.random()), Math.sin(time + Math.PI) * delta * 2);
    curRotation.multiply(incrementRotation);
    gelatine.current.setNextKinematicRotation(curRotation);
  })

  return <group position={position}>
    <RigidBody ref={gelatine} name="gelatine" type="kinematicPosition" position={[0.0, 0.0, 0.0]} >

      <mesh
        name="Gelatinous_Cube"
        castShadow
        receiveShadow
        geometry={nodes.Gelatinous_Cube.geometry}
        material={materials.Material}
        position={[-0.338, 1.868, -0.417]}
        rotation={[0, -0.003, -0.009]}>
        <MeshTransmissionMaterial
          normalScale={[0.3, 0.3]}
          roughness={0}
          ior={1.5}
          thickness={0.035}
          transmission={1}
          chromaticAberration={.12}
          anisotropy={20}
          distortion={0}
          distortionScale={0}
          temporalDistortion={0}
          samples={10}
          backside={true}
          color={"#d7f2dd"}
          attenuationDistance={0.2}
          attenuationColor={"#c0e2b3"}
          transmissionSampler />
        <mesh
          name="ax"
          castShadow
          receiveShadow
          geometry={nodes.ax.geometry}
          material={materials.ax}
          position={[0.371, 0.159, 0.067]}
          rotation={[2.052, -0.226, -1.159]}

        />
        <mesh
          name="Skeletonarm"
          castShadow
          receiveShadow
          geometry={nodes.Skeletonarm.geometry}
          material={materials['skeletonwhite.001']}
          position={[-0.065, 0.067, -0.073]}
          rotation={[0, 0.003, 0.009]}
        />
        <mesh
          name="skull"
          castShadow
          receiveShadow
          geometry={nodes.skull.geometry}
          material={materials.skeletonwhite}
          position={[0.564, -0.328, -0.116]}
          rotation={[-0.592, 0.35, 0.005]}
        />
      </mesh>


    </RigidBody>
  </group>

}


export function Model(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF('models/cube8.glb')
  const { actions } = useAnimations(animations, group)
  const treasure = useRef()

  /*  useEffect(() => {
     const action = animations.actions.Walk
     action.play()
   }, [])
  */
  /* Leva */
  const { animation } = useControls("ANIMATION", {
    animation: {
      value: "Walk",
      options: Object.keys(actions)
    }
  })

  /* Leva */
  useEffect(() => {
    actions[animation].reset().fadeIn(0.5).play()
    return () => actions[animation].fadeOut(0.5)
  }, [animation])



  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <RigidBody colliders="trimesh" type="fixed" friction={2} name="room" >
          <group name="room" position={[0.386, 0.026, -0.107]}>
            <mesh
              name="Cylinder"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder.geometry}
              material={materials['brick.001']}
            />
            <mesh
              name="Cylinder_1"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder_1.geometry}
              material={materials.Material}
            />
            <mesh
              name="Cylinder_2"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder_2.geometry}
              material={materials.wall}
            />
            <mesh
              name="Cylinder_3"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder_3.geometry}
              material={materials.Floor}
            />
            {/* flooreffect */}
            <mesh geometry={nodes.Cylinder_3.geometry}>
              <NodeToyMaterial data={data} /></mesh>
            <mesh
              name="Cylinder_4"
              castShadow
              receiveShadow
              geometry={nodes.Cylinder_4.geometry}
              material={materials['plaster.002']}
            />
          </group>
        </RigidBody>

        <mesh
          name="plank"
          castShadow
          receiveShadow
          geometry={nodes.plank.geometry}
          material={materials.Door}
          position={[-0.956, 4.043, -4.785]}
        />
        <mesh
          name="skull001"
          castShadow
          receiveShadow
          geometry={nodes.skull001.geometry}
          material={materials.skeletonwhite}
          position={[-1.143, 4.262, -4.572]}
        />
        <mesh
          name="Key"
          castShadow
          receiveShadow
          geometry={nodes.Key.geometry}
          material={materials['procedural dirty metal']}
          position={[-1.697, 4.184, -4.732]}
        />
        <group name="Mug" position={[-0.215, 4.325, -4.837]}>
          <mesh
            name="Cylinder010"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder010.geometry}
            material={materials.Door}
          />
          <mesh
            name="Cylinder010_1"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder010_1.geometry}
            material={materials.beer}
          />
          <mesh
            name="Cylinder010_2"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder010_2.geometry}
            material={materials['procedural dirty metal']}
          />
        </group>
        <group name="trap" position={[9.863, -6.58, -0.127]} rotation={[Math.PI, -0.05, Math.PI]}>
          <mesh
            name="Cube006"
            castShadow
            receiveShadow
            geometry={nodes.Cube006.geometry}
            material={materials['procedural dirty metal']}
          />
          <mesh
            name="Cube006_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube006_1.geometry}
            material={materials['plaster.002']}
          />
        </group>
        <group name="barrel001" position={[20.513, -6.599, -1.878]}>
          <mesh
            name="Cylinder002"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder002.geometry}
            material={materials.Door}
          />
          <mesh
            name="Cylinder002_1"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder002_1.geometry}
            material={materials['procedural dirty metal.001']}
          />
        </group>
        <mesh
          name="deksel001"
          castShadow
          receiveShadow
          geometry={nodes.deksel001.geometry}
          material={materials.Door}
          position={[20.513, -5.597, -1.879]}
        />
        <mesh
          name="deksel"
          castShadow
          receiveShadow
          geometry={nodes.deksel.geometry}
          material={materials.Door}
          position={[22.246, -6.291, -1.883]}
          rotation={[-0.173, -0.255, -2.095]}
        />
        <group name="barrel" position={[22.822, -6.599, -1.549]}>
          <mesh
            name="Cylinder006"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder006.geometry}
            material={materials.Door}
          />
          <mesh
            name="Cylinder006_1"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder006_1.geometry}
            material={materials['procedural dirty metal.001']}
          />
        </group>
        <mesh
          name="bogen"
          castShadow
          receiveShadow
          geometry={nodes.bogen.geometry}
          material={materials.wall}
          position={[0.386, 0.026, -0.107]}
        />
        <RigidBody colliders="cuboid" type="fixed">
          <mesh
            name="pillar001"
            castShadow
            receiveShadow
            geometry={nodes.pillar001.geometry}
            material={materials.wall}
            position={[0.386, 0.026, -0.107]}
          />
          <mesh
            name="pillar"
            castShadow
            receiveShadow
            geometry={nodes.pillar.geometry}
            material={materials.wall}
            position={[0.386, 0.026, -0.107]}
          />
        </RigidBody>
        <pointLight
          name="greenlight"
          intensity={27.757}
          decay={2}
          color="#89ff0c"
          position={[0.729, 0.748, -0.339]}
          rotation={[1.913, -0.132, 1.312]}
        />
        <pointLight
          name="redlight"
          intensity={108.703}
          decay={2}

          color="#ff6318"
          position={[8.549, 6.476, 3.864]}
          rotation={[1.978, -0.201, 1.422]}
        />
        <pointLight
          name="purplelight"
          intensity={17.81}
          decay={2}
          color="#c022ff"
          position={[17.41, -0.528, -0.658]}
          rotation={[1.913, -0.132, 1.312]}
        />
        <pointLight
          name="Point001"
          intensity={10.703}
          decay={2}
          position={[19.715, 1.21, -17.228]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <pointLight
          name="Point002"
          intensity={97.833}
          decay={2}
          color="#ffc354"
          position={[19.894, 0.11, -18.938]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          name="coin"
          castShadow
          receiveShadow
          geometry={nodes.coin.geometry}
          material={materials.coin}
          position={[20.319, 0.523, -18.043]}
          rotation={[-0.126, 0.298, 0.225]}
        />

        <group name="treasurechest" >
          <RigidBody type="fixed" name="treasure" colliders={false} position={[19.842, -0.045, -17.743]} ref={treasure}  >
            <CuboidCollider args={[2, 2, 2]} position={[0, 1, 0]} name="treasure" ref={treasure} />
            <group name="treasurechest_bottom" position={[0.0, 0.0, 0.0]}>
              <mesh
                name="treasure"
                castShadow
                receiveShadow
                geometry={nodes.Cube054.geometry}
                material={materials.treasureChest_metal}
              />
              <mesh
                name="Cube054_1"
                castShadow
                receiveShadow
                geometry={nodes.Cube054_1.geometry}
                material={materials.treasureChest_wood}
              />
            </group>

          </RigidBody>
          <group
            name="treasurechest_lid"
            position={[19.847, 1.588, -18.433]}
            rotation={[-1.134, 0, 0]}>
            <mesh
              name="Cube048"
              castShadow
              receiveShadow
              geometry={nodes.Cube048.geometry}
              material={materials.treasureChest_metal}
            />
            <mesh
              name="Cube048_1"
              castShadow
              receiveShadow
              geometry={nodes.Cube048_1.geometry}
              material={materials.treasureChest_wood}
            />
          </group>
          <mesh
            name="woodenplanks"
            castShadow
            receiveShadow
            geometry={nodes.woodenplanks.geometry}
            material={materials.treasureChest_woodfloor}
            position={[20.746, -0.147, -18.634]}
            rotation={[0, 0, -Math.PI / 2]}
          />
        </group>

        <Gelatinous_Cube />

        <group  name="gelatinous_cube__sm" position={[0,0,0]} >
          <mesh
            name="gelatinous_cube__sm"
            geometry={nodes.gelatinous_cube__sm.geometry}
            material={materials.Material}
            position={[0.492, 1, 0.074]}
            rotation={[-0.314, 0.071, 0.501]}
          >
          <MeshTransmissionMaterial
            normalScale={[0.3, 0.3]}
            roughness={0}
            ior={1.5}
            thickness={0.0035}
            transmission={3.5}
            chromaticAberration={.12}
            anisotropy={20}
            distortion={0}
            distortionScale={0}
            temporalDistortion={0}
            samples={10}
            backside={true}
            color={"#593838"}
            attenuationDistance={0.2}
            attenuationColor={"#bea273"}
            transmissionSampler />
            </mesh>
        </group>
        <group name="Armature" position={[20.235, -0.359, -12.202]} rotation={[Math.PI / 2, 0, 0]}>
          <skinnedMesh
            name="ArmbandBovenarmlp_Cylinder005_OrcLowPolyMat"

            geometry={nodes.ArmbandBovenarmlp_Cylinder005_OrcLowPolyMat.geometry}

            material={materials.OrcLowPolyMat}

            skeleton={nodes.ArmbandBovenarmlp_Cylinder005_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="eyes_Sphere003_OrcLowPolyMat"
            geometry={nodes.eyes_Sphere003_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.eyes_Sphere003_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="hornLlowpoly_Cube011_OrcLowPolyMat"
            geometry={nodes.hornLlowpoly_Cube011_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.hornLlowpoly_Cube011_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="hornRlowpoly_Cube012_OrcLowPolyMat"
            geometry={nodes.hornRlowpoly_Cube012_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.hornRlowpoly_Cube012_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="JudoKnotlp_Cube018_OrcLowPolyMat"
            geometry={nodes.JudoKnotlp_Cube018_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.JudoKnotlp_Cube018_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="loincloth_frontlp_Plane005_OrcLowPolyMat"
            geometry={nodes.loincloth_frontlp_Plane005_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.loincloth_frontlp_Plane005_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="loinclothbacklp_Plane004_OrcLowPolyMat"
            geometry={nodes.loinclothbacklp_Plane004_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.loinclothbacklp_Plane004_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="MonsterLP_Plane001_OrcLowPolyMat"
            geometry={nodes.MonsterLP_Plane001_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.MonsterLP_Plane001_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Polsarmbandlp_Cylinder004_OrcLowPolyMat"
            geometry={nodes.Polsarmbandlp_Cylinder004_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Polsarmbandlp_Cylinder004_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Shacklelp_Torus006_OrcLowPolyMat"
            geometry={nodes.Shacklelp_Torus006_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Shacklelp_Torus006_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Spherelp_Sphere001_OrcLowPolyMat"
            geometry={nodes.Spherelp_Sphere001_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Spherelp_Sphere001_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Teeth1LowPoly_Cube015_OrcLowPolyMat"
            geometry={nodes.Teeth1LowPoly_Cube015_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Teeth1LowPoly_Cube015_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="TeethLlowpoly_Cube013_OrcLowPolyMat"
            geometry={nodes.TeethLlowpoly_Cube013_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.TeethLlowpoly_Cube013_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Teethmidlowpoly_Cube017_OrcLowPolyMat"
            geometry={nodes.Teethmidlowpoly_Cube017_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Teethmidlowpoly_Cube017_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Teeth3lowpl;y_Cube016_OrcLowPolyMat"
            geometry={nodes['Teeth3lowpl;y_Cube016_OrcLowPolyMat'].geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes['Teeth3lowpl;y_Cube016_OrcLowPolyMat'].skeleton}
          />
          <skinnedMesh
            name="ToothRlowpoly_Cube014_OrcLowPolyMat"
            geometry={nodes.ToothRlowpoly_Cube014_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.ToothRlowpoly_Cube014_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Toruslp_Torus008_OrcLowPolyMat"
            geometry={nodes.Toruslp_Torus008_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Toruslp_Torus008_OrcLowPolyMat.skeleton}
          />
          <skinnedMesh
            name="Torus2lp_Torus007_OrcLowPolyMat"
            geometry={nodes.Torus2lp_Torus007_OrcLowPolyMat.geometry}
            material={materials.OrcLowPolyMat}
            skeleton={nodes.Torus2lp_Torus007_OrcLowPolyMat.skeleton}
          />
          <primitive object={nodes.mixamorigHips} />
        </group>

        <Door />
        <Gate />
        <FloorGrate />

      </group>
    </group >
  )
}

useGLTF.preload('models/cube8.glb')